var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.768 10.546a.754.754 0 0 0 0-1.088l-5.5-5.25a.75.75 0 0 0-1.034 1.084l4.143 3.96H3.75a.75.75 0 0 0-.75.75c0 .415.335.75.75.75h10.628l-4.147 3.956a.75.75 0 0 0 1.035 1.084l5.5-5.25z"
  })));
};
export default SvgArrowRight;